export default {
  common: {
    label: {
      identityCard: 'National ID',
      identityCardFront: 'ID Front',
      identityCardBack: 'ID Back',
      identityCardHold: 'Holding ID Photo',
      passport: 'Passport',
      driverLicense: '驾驶证',
      other: '其他',
      upload: 'upload'
    },
    content: {
      identityCardFront: 'ID Front',
      identityCardBack: 'ID Back',
      identityCardHold: 'Please upload a picture of the individual holding up the front of your ID. (We recommend using your back camera to ensure the image and your ID is clear and visible)',
      passport: 'Passport',
      passportHold: 'Please upload a picture of the individual holiding up the passport first page. (We recommend using your back camera to ensure the image and your ID is clear and visible)',
      identityCardHint: "Please upload a photo / scanned copy of your government-issued personal ID card. Move the mouse over to the upload box to view the sample",
      passportHint: "Please upload picture / scanned copy of government-issued passport. Move mouse over to upload box to view sample",

    },
    placeholder: {
      identityCardFront: 'Please upload ID front',
      identityCardBack: 'Please upload ID back',
      identityCardHold: 'Please upload ID holding photo',
      passport: 'Please upload picture / scanned copy of government-issued passport. Move mouse over to upload box to view sample',
      driverLicense: '请上传驾驶证',
      other: '请上传其他证件'
    },
    validate: {
      passport: "Please upload ID document",
      passportHold: "Please upload a picture of the individual holding up the passport first page",
      mobilePhone: "Please enter a valid mobile number.",
      mobilePhoneCode: "Please enter your mobile verification code.",
      email: "Please enter a valid email address.",
      emailUniqueness: "The email address is already in use. ",
      emailCode: "Enter email verification code",
      password: "Please enter password.",
      passwordRule: "Your password has to be between 6-16 alpha-numeric characters with no special characters.",
      confirmPassword: "Please re-enter your password",
      passwordInconsistent: "The passwords do not match.",
      amount: "Please enter amo",
      loginName: "Please enter user name",
      characterSet: "Please enter valid characters.",
      characterLength: "Your entry should not exceed {char} characters",
      idCard: "Please enter a valid ID no. ",
    }
  },
  global: {
    content: { // global.content.text_1
      text_1: 'Sunrate Merchant Referral Programme', // 寻汇Sunrate营销会员账户
      text_2: 'Success', // 寻汇Sunrate营销会员账户
      text_3: 'Uploaded successfully',
      text_4: 'Upload failed',
      text_5: 'Edited successfully ',
      text_6: 'Added successfully',
      text_7: 'You have not completed your identity verification, please complete your verification first.',
      text_8: 'Upload',
      text_9: 'View',
      text_10: 'Re-upload',
      text_11: 'Copy',
      text_12: 'Copy successfully',
      text_13: 'No Start Date',
      text_14: 'No End Date',
      text_15: 'Download Agreement',
      text_16: '《寻汇营销会员合作协议》',
    },
    validate: { // global.validate.text_1
      mobilePhone: "Please enter a valid mobile number.",
      mobilePhoneCode: "Please enter your mobile verification code.",
      email: "Please enter a valid email address.",
      emailUniqueness: "The email address is already in use. ",
      emailCode: "Enter email verification code",
      password: "Please enter password.",
      passwordRule: "Your password has to be between 6-16 alpha-numeric characters with no special characters.",
      confirmPassword: "Please re-enter your password",
      passwordInconsistent: "The passwords do not match.",
      amount: "Please enter amo",
      loginName: "Please enter user name",
      characterSet: "Please enter valid characters.",
      characterLength: "Your entry should not exceed {char} characters",
      idCard: "Please enter a valid ID no. ",
    },
    label: { // global.label.text_1
      email: "E-mail",
      emailCode: "Email verification code",
      cellphone: "Cellphone number",
      cellphoneCode: "Mobile number verification code",
      newPassword: "New password",
      confirmPassword: "Confirm password"
    },
    btn: {
      submit: "Submit",
      cellphone: "Recover password via email",
      email: "Recover password via mobile phone"
    },
    dialog: {
      title: {
        text_1: 'Note',
      },
      content: { // global.dialog.content.text_1
        text_1: 'Confirm ',
        text_2: 'Cancel',
        text_3: 'Changing your verfication method will result in the loss of your current information. Please confirm you want to make the change.',
      }
    },
    bindEmailDialog: {
      title: { // global.bindEmailDialog.title.text_1
        text_1: '绑定邮箱通知', // 绑定邮箱通知
      },
      content: { // global.bindEmailDialog.content.text_1
        text_1: '当前账户手机号', // 当前账户手机号
        text_2: '绑定邮箱地址', // 绑定邮箱地址
        text_3: '邮箱验证码', // 邮箱验证码
        text_4: '确认绑定', // 确认绑定
        text_5: 'The verification number is no longer valid. Please request a new one.', // 邮箱验证码失效,请重新获取
        text_6: 'Account & Security',
        text_7: 'Switch Language',
        text_8: 'Log Out',
      },
    }
  },
  commonBtn: {
    btn: {
      submit: 'Submit',
      cancel: 'Cancel',
    }
  },
  enum: { // enum.text_1
    text_1: 'Dashboard',
    text_2: 'Referral List',
    text_3: 'Collection List',
    text_4: 'Payment List',
    text_5: 'Information',
    text_6: 'Account',
    text_7: 'Registration Success',
    text_8: 'Registration',
    text_9: 'Recover password',
    text_10: 'Login',
    text_11: 'Page not found',
    text_12: 'You do not have permission to access this page.',
    text_13: 'Settlement',
    text_14: 'Partner Settlement',
    text_15: 'Sales Settlement',
    text_16: 'Referral Customer Management',
    text_17: 'Pending Referral Customers List',
    text_18: 'Active Referral Customers List',
  },
  user: {
    register: {
      title: { // user.register.title.text_1
        text_1: 'Register for a Merchant Referral Account',
        text_2: 'Email Address',
        text_3: 'Mobile number',
        text_4: 'Password',
        text_5: 'Referred by (optional)',
        text_6: 'Referral Code', // 推荐码
      },
      placeholder: { // user.register.placeholder.text_1
        text_1: 'Please enter your email address.',
        text_2: 'Enter verification code.',
        text_3: 'Please enter your mobile number',
        text_4: 'Please enter password.',
        text_5: 'Please re-enter your password',
        text_6: 'Optional ',
      },
      error: { // user.register.error.text_1
        text_1: 'Please enter a valid email address.',
        text_2: 'Enter email verification code',
        text_3: 'Please enter a valid mobile number.',
        text_4: 'Enter mobile phone verification code',
        text_5: 'Please read and agree to the Terms of Service and Sunrate Privacy Policy',
        text_6: 'Please agree to the service agreement first'
      },
      content: { // user.register.content.text_1
        text_1: 'Send Code',
        text_2: '默认+65',
        text_3: 'I have read and agree to ',
        text_3_1: 'Terms of Service',
        text_3_2: 'and',
        text_3_3: 'Sunrate Privacy Policy',
        text_3_4: 'I have read and agree to the Terms of Service and Sunrate Privacy Policy', // 我已阅读并同意 《寻汇营销会员合作协议》与《Sunrate隐私政策》
        text_3_5: 'I have read and agreed to the cross-border transfer of my personal information in accordance with the ', // the cross-border transfer of my personal information in accordance with the Sunrate Privacy Policy
        text_3_6: '', // 英文不需要额外后缀
        text_4: 'Have an account? Log in here.',
        text_5: 'Register now',
        text_6: 'Regain', // 重新获取,Regain
      },
    },
    login: {
      title: { // user.login.title.text_1
        text_1: 'Sunrate Referral Programme',
        text_2: 'Mobile Number Login',
        text_3: 'Email Login ',
      },
      placeholder: { // user.login.placeholder.text_1
        text_1: 'Email',
        text_2: 'Mobile',
        text_3: 'Password',
      },
      error: { // user.login.error.text_1
        text_1: 'Drag the slider to the right to complete verification ',
        text_2: 'User cannot be left empty.',
        text_3: 'Please enter password.',
      },
      content: { // user.login.content.text_1
        text_1: 'Drag the slider to the right to complete verification.',
        text_2: 'Forgot your password? ',
        text_3_1: 'New to Sunrate?', // 没有账户?去注册
        text_3_2: 'Sign up for free.', // 没有账户?去注册
        text_4: 'Login',
        text_5: 'Verification confirmed.',
        text_6: 'Login successful!',
      },
    },
    setting: {
      title: { // user.setting.title.text_1
        text_1: 'Personal Details', // 个人信息
        text_2: 'Security Details', // 安全信息
      },
      form: { // user.setting.form.text_1
        text_1: 'Account ID', // 账户编号
        text_2: 'Old Password', // 原密码
        text_3: 'New Password', // 新密码
        text_4: 'Confirm New Password', // 确认新密码
        text_5: 'Mobile No.', // 手机号
        text_6: 'E-mail', // E-mail
      },
      placeholder: { // user.setting.placeholder.text_1
        text_1: 'Please enter your old password.', // 请输入原密码
        text_2: 'Please enter your new password.', // 请输入新密码
        text_3: 'Please re-enter your new password.', // 请确认新密码
      },
      content: { // user.setting.content.text_1
        text_1: 'You need to verify your original password before changing a new password. If the new password field is not filled, your password cannot be changed.',
        text_2: 'You can retrieve your password through your mobile no. or email address.',
        text_3: 'Confirm',
        completeIdentityThenSignAgreement: "Please complete identity verification before signing the agreement.",
        downloadSignUploadAgreementAgain: "Please download, sign/stamp, and upload the scanned copy.",
        downloadSignUploadClearAgreement: "Download \"Business Introduction Agreement\", sign, stamp, and upload a clear scan.",
        signedSuccessfully:"Signed Successfully",
        collectionCurrency:"Collection Currency",
      },
    },
    forgetPassword: {
      title: { // user.forgetPassword.title.text_1
        text_1: 'Recover password'
      },
      content: { // user.forgetPassword.content.text_1
        text_1: '恭喜您密码修改成功',
        text_2: '（{timeout}s后返回登录）',
        text_3: '登入平台',
      }
    }
  },
  dashboard: {
    remarkDialog: {
      title: 'Update Remark',
      submitBtn: 'Submit',
      cancelBtn: 'Cancel',
      placeholder: 'Please enter remark content',
      validate: {
        remarkRequired: 'Please enter remark content'
      }
    },
    step: {
      title: { // dashboard.step.title.text_1
        text_1: 'Name Authentication',
        text_2: 'Authentication under review.',
        text_3: 'Authentication Successful',
        text_4: 'Authentication Failed',
        text_5: 'Upload agreement',
        text_6: 'Agreement under review',
        text_7: 'Agreement approved',
        text_8: 'Agreement rejected',
        text_9: 'Add bank account.',
        text_10: 'Bank Account Under Review',
        text_11: 'Bank Account Approved ',
        text_12: 'Bank Account Rejected',
        text_13: 'Registration information submitted',
        accountRegistration: 'Account Registration',
        identityVerification: 'Identity Verification',
        signAgreement: 'Sign Agreement',
        termsAndPolicies: 'Terms & Policies',
        collectionBankAccount: 'Collection Bank Account',
      },
      other: { // dashboard.step.other.text_1
        text_1: 'Please complete the previous steps before proceeding.',
      },
      content: { // dashboard.step.content.text_1
        text_1: 'Congratulations, you have completed the {regType} verification, please complete your account setup.',
        text_1_2: 'Corporate',
        text_1_3: 'Individual',
        text_2: 'Your documents are under review. We appreciate your patience.',
        text_3: 'Your application cannot be processed because risk score does not meet our requirements. If you have any queries, please queries, please contact our support team.',
        text_4: 'Your documents have been rejected. Please',
        text_4_1: 'Resubmit', // 您提交的材料未通过审核，请及时(去修改)
        text_5: 'You have not completed your identity authentication, please',
        text_6: 'click here', // 去认证
        text_7: 'Congratulations, your user agreement has been approved and your referral link has been generated. Please update your bank account details promptly.',
        text_8: 'Uploaded "Business Introduction Agreement"',
        text_9: 'Download and sign "Business Introduction Agreement". Upload a clear and completed version of the agreement. ',
        text_10: 'Download <a href="{bizIntAgreement}" download="Business Introduction Agreement">Business Introduction Agreement</a>. Upload a clear and completed version of the agreement.',
        text_10_1: 'Re-upload', // 再次上传
        text_10_2: 'Reason for Return', // 驳回原因
        text_10_3: 'Upload here', // 点击上传
        text_11: 'Bank account approved.',
        text_12: 'Your bank account has been added. We appreciate your patience while we complete the review.',
        text_13: 'For subsequent settlement of commission, please add a bank account that is consistent with your registered name. Ensure that the information provided is accurate.',
        text_15: 'Check', // 去查看
        text_15_2: 'Check >', // 去查看
        text_16: 'Edit', // 去修改
        text_17: 'Reason for Return', // 驳回原因
        text_18: 'Add here', // 去添加
        text_19: 'Add here', // 去添加
        accountRegistrationTip: 'Registration complete. Please continue to setup.',
        accountRegistrationTip2: 'Completed',
        identityVerificationTip: 'Please complete your identity details to start business.',
        identityVerificationTip2: 'Verify Now',
        identityVerificationTipCP: 'Submission received. Expedited review in progress...',
        identityVerificationTipCP2: 'Under Review',
        identityVerificationTipRJ: 'Verification failed.',
        identityVerificationTipRJ3: 'Resubmit',
        identityVerificationTipCF: 'Identity verified. Please proceed to sign agreement.',
        identityVerificationTipCF2: 'Completed',
        signAgreementTip: 'Please download, sign/stamp, and upload the scanned copy.',
        signAgreementTip2: 'Download "Business Introduction Agreement" Template',
        signAgreementTip3: 'Upload File',
        signAgreementTip4: 'Business Introduction Agreement',
        signAgreementTipCP: 'Agreement under review. Est. time: 1 business day.',
        signAgreementTipCP2: 'Under Review',
        signAgreementTipRJ: 'Please check and re-upload.',
        signAgreementTipRJ2: 'Download Agreement "Business Introduction Agreement"',
        signAgreementTipRJ3: 'Re-upload',
        signAgreementTipRJ4: 'Agreement rejected',
        signAgreementTipRJ5: 'Agreement rejected.Please check and re-upload.',
      },
    },
    table: { // dashboard.table.text_1
      text_1: 'Customer Referral List',
      text_2: 'Customer Name',
      text_3: 'Customer ID',
      text_4: 'Status',
      text_5: 'Valid Date',
      text_6: 'Date',
      text_7: 'Invite Code',
    },
    dialog: {
      title: { // dashboard.dialog.title.text_1
        text_1: 'Add Bank Account', // 添加收款银行账户
        text_2: 'Bank Account', // 收款银行账户
      },
      content: { // dashboard.dialog.content.text_1
        text_1: '1. Please add a bank account that is consistent with your registered name, Ensure that the information provided is accurate.', // 1、请添加与您注册名称一致的银行账户并确保信息准确、无误;
        text_2: '2.【Account Type】Please select accordingly, for corporate registrations select Corporate Account, for individual registrations, select Individual Account ', // 2、【银行账户类型】请按照实际情况进行填写，企业请选择"企业账户",个人请选择"个人账户";
        text_3: 'Cancel',
        text_4: 'Confirm',
        text_5: 'Got it.',
        text_6: 'No Data',
        text_7: 'Congratulation, your account has been approved. Your valid settlement date will be {start} to {end}',
        text_8: 'Expires today.',
        text_9: 'To expire after {day} days.',
        text_10: 'Expired.',
        text_11: 'No start date.',
        text_12: 'No end date.',
        text_13: 'Not configured yet.',
      },
      layout: { // dashboard.dialog.layout.text_1
        text_1: '600px', // 对话框宽度
        text_2: '180px', // 标签宽度
      },
      select: { // dashboard.select.text_1
        text_1: 'ename', // 下拉框显示英文名称
      },
      label: { // dashboard.dialog.label.text_1
        text_1: 'Location',
        text_2: 'Bank Account Type',
        text_3: 'Bank Account Name',
        text_4: 'Currency',
        text_5: 'Bank Account No.',
        text_6: 'Contact Information',
        text_7: 'ID No.',
        text_8: 'Bank Name',
        text_9: 'Bank District',
        text_10: 'Bank Account',
        text_11: 'Review Status ',
        text_12: 'Currency ',
        text_13: 'Contact Information',
      },
      placeholder: { // dashboard.dialog.placeholder.text_1
        text_1: 'Mainland China',
        text_2: 'Hong Kong (China)',
        text_3: 'Singapore',
        text_4: 'Corporate Account',
        text_5: 'Individual Account',
        text_6: 'Please enter account name.',
        text_7: 'Please enter bank account.',
        text_8: 'Please enter your contact information.',
        text_9: 'Please enter your ID number.',
        text_10: 'Please enter your bank name (including branch informaton).',
        text_11: 'Please enter your bank location.',
      }
    },
    share: { // dashboard.share.title.text_1
      title: {
        text_1: 'Invitation Link', // 推荐链接
        search:"Please enter invite code to search"
      },
      content: { // dashboard.share.content.text_1
        text_1: 'Each member has a unique invitation link. Click below to copy the link to invite new users.', // 每个会员都拥有唯一的推荐链接，点击下方的复制即可用来推荐他人使用。
        text_2: 'Link not generated.', // 暂未生成链接
        text_3: 'Sales Representative', // 绑定销售
        text_4: 'Sunrate Platform Invitation Link', // 全球支付平台推广链接
      },
    },
    bank: {
      title: { // dashboard.bank.title.text_1
        text_1: 'My Bank Account'
      },
      content: { // dashboard.bank.content.text_1
        text_1: 'Bank Account Name', // 收款账户名称
        text_2: 'Currency', // 收款币种
        text_3: 'Approved', // 已通过
        text_4: 'Returned', // 已驳回
        text_5: 'Under Review', // 审核中
        text_6: 'Rejected', // 未通过
        text_7: 'Under Review', // 审核中
        text_8: 'Awaiting Review', // 待审核
        addBankAcct: 'Add bank account',
      },
      error: {
        text_1: "Enter Account Type", // 请选择账户类型
        text_2: "Please select bank account type", // 请选择收款账户类型
        text_3: "Please enter the bank's province", // 请填写银行所在省份
        text_4: "Please select currency", // 请选择交易币种
        text_5: "Please enter your ID number.", // 请输入身份证号码
        text_6: "Please enter the bank location.", // 请输入银行开户地区
        text_7: "未获取到银行卡信息", // 未获取到银行卡信息
      }
    },
    overview: { // dashboard.overview
      title: 'Overview',
      timeHint: 'Last',
      days7: 'Last 7 Days',
      days30: 'Last 30 Days',
      days90: 'Last 90 Days',
      registerCount: 'Total Registered Customers',
      openAcctCount: 'Total Account Openings',
      transinUsdAmt: 'Total Receipts (USD)',
      incomeUsdAmt: 'Total Payments (USD)',
      conversionRate: 'Account Conversion Rate',
      payTrend: 'Payment Transaction Trend',
      transinTrend: 'Receipt Transaction Trend'
    },
  },
  cascade: {
    transMode: {
      1: {
        1: "1. Live Animals, Animal Products",
        2: "2. Fresh Fruits and Vegetables & Other Vegetable Products",
        3: "3. Animal and Vegetable Fats & Oils, Prepared Edible Fats, Animal Or Vegetable Waxes",
        4: "4. Prepared Foodstuffs, Beverages, Spirits, Vinegar & Tobacco Products",
        5: "5. Mineral Products",
        6: "6. Chemical Products",
        7: "7. Plastic and Rubber Products",
        8: "8. Leather, Handbags, Travel Goods, Saddlery, Harness, Raw Hides and Skins, Furskins & Animal Gut Products",
        9: "9. Wood & Wood Products, Wood Charcoal, Cork, Basketware, Wickerwork",
        10: "10. Paper & Paperboard Products, Wood Pulp, Paper Waste & Scrap",
        11: "11. Textile, Clothing & Home Textiles",
        12: "12. Footwear, Headgear, Artificial Flowers, Umbrellas, Walking Sticks, Seatsticks, Whips, Riding-Crops, Prepared Feathers, Hair Products",
        13: "13. Stone, Marble, Plaster, Cement, Asbestos, Mica Products, Ceramic Products, Glass & Glassware",
        14: "14. Jewelry, Precious Metals, Precious & Semiprecious Stones, Pearls, Imitation Jewelry, Coin",
        15: "15. Metals & Metal Products",
        16: "16. Machinery, Electronics, Electrical Equipment",
        17: "17. Vehicles, Aircraft, Vessels & Other Transport Equipment",
        18: "18. Medical Instruments, Optical, Photographic, Cinematographic, Measuring, Checking, Precision Instruments, Clocks&Watches, Musical Instruments",
        19: "19. Arms And Ammunition",
        20: "20. Miscellaneous Products",
        21: "21. Antiques, Art Works, Collectors' Pieces",
        22: "22. Special Trade & Unclassified Goods"
      },
      2: {
        1: "1. Live Animals, Animal Products",
        2: "2. Fresh Fruits and Vegetables & Other Vegetable Products",
        3: "3. Animal and Vegetable Fats & Oils, Prepared Edible Fats, Animal Or Vegetable Waxes",
        4: "4. Prepared Foodstuffs, Beverages, Spirits, Vinegar & Tobacco Products",
        5: "5. Mineral Products",
        6: "6. Chemical Products",
        7: "7. Plastic and Rubber Products",
        8: "8. Leather, Handbags, Travel Goods, Saddlery, Harness, Raw Hides and Skins, Furskins & Animal Gut Products",
        9: "9. Wood & Wood Products, Wood Charcoal, Cork, Basketware, Wickerwork",
        10: "10. Paper & Paperboard Products, Wood Pulp, Paper Waste & Scrap",
        11: "11. Textile, Clothing & Home Textiles",
        12: "12. Footwear, Headgear, Artificial Flowers, Umbrellas, Walking Sticks, Seatsticks, Whips, Riding-Crops, Prepared Feathers, Hair Products",
        13: "13. Stone, Marble, Plaster, Cement, Asbestos, Mica Products, Ceramic Products, Glass & Glassware",
        14: "14. Jewelry, Precious Metals, Precious & Semiprecious Stones, Pearls, Imitation Jewelry, Coin",
        15: "15. Metals & Metal Products",
        16: "16. Machinery, Electronics, Electrical Equipment",
        17: "17. Vehicles, Aircraft, Vessels & Other Transport Equipment",
        18: "18. Medical Instruments, Optical, Photographic, Cinematographic, Measuring, Checking, Precision Instruments, Clocks&Watches, Musical Instruments",
        19: "19. Arms And Ammunition",
        20: "20. Miscellaneous Products",
        21: "21. Antiques, Art Works, Collectors' Pieces",
        22: "22. Special Trade & Unclassified Goods"
      },
      3: {
        1: "Clothing / Shoes / Luggage",
        2: "Beauty / Personal Health Care",
        3: "Kitchenware / Home Furnishings",
        4: "Toys / Mothers and Babies Products",
        5: "Computer / Office Stationery",
        6: "Outdoor sports",
        7: "Mobile / Photography / Digital Products",
        8: "Electronic Accessories / Smart Home Devices",
        9: "Food / Nutritional Supplements",
        10: "Home Appliances / Furnitures",
        11: "Games / Musical instruments",
        12: "Clocks & Watches / Jewellery",
        99: "Others"
      },
      4: {
        1: "Clothing / Shoes / Luggage",
        2: "Beauty / Personal Health Care",
        3: "Kitchenware / Home Furnishings",
        4: "Toys / Mothers and Babies Products",
        5: "Computer / Office Stationery",
        6: "Outdoor sports",
        7: "Mobile / Photography / Digital Products",
        8: "Electronic Accessories / Smart Home Devices",
        9: "Food / Nutritional Supplements",
        10: "Home Appliances / Furnitures",
        11: "Games / Musical instruments",
        12: "Clocks & Watches / Jewellery",
        99: "Others"
      },
      5: {
        1: "Education Agencies",
        2: "Overseas Training / Education",
        99: "Others"
      },
      6: {
        1: "Travel Agencies ",
        2: "Airlines",
        3: "OTA",
        99: "Others"
      },
      7: {
        1: "Logistics",
        2: "Advertisements ",
        3: "Gaming",
        4: "Live Stream",
        5: "Hotels / Guesthouse ",
        99: "Others"
      },
      8: {
        1: "China Onshore PSPs",
        2: "Overseas PSPs"
      }
    }
  },
  dict: {
    annualSales: {
      A: "Below $50,000",
      B: "$50,000 - $500,000",
      C: "$500,000 - $3,000,000",
      D: "$3,000,000 - $8,000,000",
      E: "Above $8,000,000"
    },
    companyScale: {
      1: "< 20",
      2: "20-50",
      3: "50-100",
      4: "100-300",
      5: "300-1000",
      6: "> 1000"
    },
    transMode: {
      1: "B2B Importers",
      2: "B2B Exporters",
      3: "E-commerce Importers",
      4: "E-commerce Exporters",
      5: "Education",
      6: "Travel & Tourism",
      7: "Service Trade",
      8: "China Onshore / Overseas PSPs"
    },
    tradeOpponent: {
      US: "United States of America ",
      CA: "Canada",
      GB: "England ",
      EU: "Europe",
      HK: "China / Hong Kong",
      SG: "Singapore",
      JP: "Japan",
      AU: "Australia ",
      NZ: "New Zealand"
    },
    eptMonthAmt: {
      1: "< 100,000USD",
      2: "100,000USD to 300,000USD",
      3: "300,000USD to 500,000USD",
      4: "500,000USD to 1,000,000USD",
      5: "1,000,000USD to 2,000,000USD",
      6: "2,000,000USD to 5,000,000USD",
      7: "5,000,000USD to 10,000,000USD",
      8: "> 10,000,000USD"
    },
    onsite: {
      1: "Yes",
      0: "No"
    },
    fxTxnStatus: {
      "01": "Pending Confirmation",
      "02": "Currency locked in",
      "03": "Currency locked in",
      "04": "Processing",
      "05": "Processing",
      "09": "Paid out",
      20: "Cancelled",
      30: "Voided"
    },
    label: {
      acctId: "Client ID",
      acctName: "Client Name",
      annualSales: "Average monthly sales in the past year(USD)",
      companyScale: "Company Size",
      transMode: "Business Category",
      tradeType: "Nature of Business / Activities",
      commodityDesc: "Nature of Business",
      tradeOpponent: "Countries Receiving / Sending Payments",
      transCur: "Currencies to be Traded w/ Sunrate",
      eptMonthAmt: "Estimated Monthly TPV",
      otherInformation: "Remarks",
      image: "Visit Summary",
      selfCheckFileInfoList: "Self-inspection Documents",
      title: 'KYC Update',
      scoreAuditResult: "Audit Results",
      complianceRemark: "Audit Remarks",
    },
    growKycScore: {
      unrated: "未评分",
      excellent: "Outstanding",
      pass: "Qualified",
      notPass: "Unqualified"
    },
    validate: {
      acctName: "Please enter corporate name",
      acctNameRequired: "Required: Please fill in the Company Name. For example: xxx Company or xxx Pte Ltd ",
      category: "Please select lead type",
      source: "Please select lead source",
      leadSourceCode: "Please select event code",
      typeFlag: "Please select lead category",
      importLevel: "Please determine lead potential",
      address: "Please enter lead potential",
      addressRequired: "Required: Please fill in the Client's office address, such as \"39 Robinson Rd, Singapore 068911\"",
      competingCompany: "Please specify competitors",
      contactName: "Please fill in the contact name",
      contactPosition: "Please select contact title",
      contactMobile: "Please enter contact information",
      contactMobileRequired: "Required; eg. phone number or Wechat account ID.",
      contactEmail: "Please enter contact email",
      location: "Click to retrieve current location",
      locationRequired: "Click to retrieve current location",
      content: "Please enter content",
      remark: "If any, please fill in the details",
      image: "Please upload visit summary",
      selfCheckFileInfoList: "Please upload self-inspection documents",
      searchAcctName: "Please enter client name",
      annualSales: "Please select amount for average monthly sales in the past year",
      companyScale: "Please input company size",
      transMode: "Please select business category",
      tradeType: "Please specify company's nature of business",
      commodityDesc: "Please describe Client's business activities in details ",
      tradeOpponent: "Please select Countries Receiving / Sending Payments",
      transCur: "Please select currencies ",
      eptMonthAmt: "Please determine monthly TPV",
      otherInformation: "If any, please fill in the details",
      fileVerify: "Please select ID verification",
      fileVerifyInfoList: "Please upload ID attachment",
      interviewVoucher: "Please upload interview documents",
      authVoucher: "Please upload proof of verification"
    }
  },
  auth: {
    company: {
      register: {
        title: { // auth.company.register.title.text_1
          text_1: 'Applicant Information'
        },
        label: { // auth.company.register.label.text_1
          text_1: 'Role',
          text_2: 'Legal Representative/Director',
          text_3: 'Authorised Representative',
          text_4: 'Name',
          text_5: 'Full Legal name',
          text_6: 'Authorisation letter',
          text_7: "ID Type",
          issuingCountry: "Issuing Country",
          country: "Country/Region"
        },
        placeholder: { // auth.company.register.placeholder.text_1
          text_1: "Please enter your full legal name",
          text_2: "Please enter authorized representative name",
          text_3: '', // todo 空下就好
          text_4: 'ID Front',
          text_5: 'ID Back',
          text_6: 'ID card (front)',
          text_7: 'ID card (back)',
        },
        content: { // auth.company.register.content.text_1
          text_1: "All materials submitted will only be used for commercial purposes. Sunrate's platform permits the upload of documents with personal watermarks.", // 所有材料将不会用于双方业务之外的其他用途，且平台支持您上传有个人水印的材料。
          text_3: 'ID Front', // 身份证人像面（照片、文字清晰且边框完整）
          text_4: 'ID Back', // 身份证国徽面（文字清晰且边框完整）
          text_5: 'Please upload Authorisation Letter',
          text_5_2: 'Download Sample>>>',
          text_6: '*Acceptable file types: JPG, JPEG, PNG, BMP, PDF; Maximum file size: 5MB.',
          text_6_2: 'See Example',
          text_7: 'All materials submitted will only be used for commercial purposes. Sunrate can accept documents with personal watermarks.',
        },
        error: { // auth.company.register.error.text_1
          text_1: "Please upload Authorisation Letter", // 请上传授权书
          text_2: "Please enter your full legal name", // 请输入法人的姓名
          text_3: "Please enter authorized representative name", // 请输入授权人的姓名
          text_4: "Please select your role", // 请选择您的身份,
          issuingCountry: 'Please select issuing country',// 请选择证件签发地
          issuingCountry2: 'Select country/region',// 请选择企业注册所在地
        },
      },
      info: { // auth.company.info.text_1
        title: { // auth.company.info.title.text_1
          text_1: 'Corporate Information'
        },
        label: { // auth.company.info.label.text_1
          text_1: 'Local Corporate Name', // 企业名称
          text_2: 'Corporate Name', // 企业英文名称
          text_3: 'Registered Country', // 企业注册所在地
          text_4: 'Local Business Operating Address', // 企业经营地址
          text_5: 'Business Operating Address (English)', // 企业经营英文地址
          text_6: 'ID Type', // 证件类型
          text_7: 'Certificate of Incorporation', // 企业证书
        },
        placeholder: { // auth.company.info.placeholder.text_1
          text_1: 'Please enter corporate name',
          text_2: 'Please enter corporate name',
          text_3: "Please enter business operatiing address, including unit no.",
          text_4: 'Please select country of origin',
          text_5: 'Please enter your business operating address', // 请输入企业经营地址
          text_6: 'Please enter business operatiing address in English or pinyin', // 请输入企业经营地址英文或者拼音
        },
        content: { // auth.company.info.content.text_1
          text_1: 'Director',
          text_2: 'For companies without a Mandarin name, fill in your English name here.',
          text_3: "Please fill in your company's english name or pinyin name.",
          text_4: ' Business certification.', // 营业执照
          text_CN: 'Mainland China entities: Upload the latest version of your Business License scanned copy,', // 中国大陆企业请上传营业执照扫描件
          text_TW: 'Upload the latest version of your Business License scanned copy,',
          text_5_1: 'For Indonesia businesses, upload the full and latest copy of your NIB license.', // 中国大陆企业请上传营业执照扫描件
          text_HK: 'Hong Kong SAR entities: Upload the latest Business Registration Certificate (BR) and Certificate of Incorporation (CI) scanned copy,', // 中国香港企业请上传商业登记证书BR和公司注册证书CI扫描件
          text_PK: 'Business documents must be issued within a year. Please upload controller and ownership information (e.g. AoA or equivalent)，',
          text_7: 'For Singapore businesses, upload the full and latest copy of your ACRA bizfile.',
          text_8: 'the file format should only be jpg, jpeg, png, bmp or pdf (Please ensure visibility of content, max file size 5MB).',
          text_8_1: '', 
          text_9: 'BR', // BR
          text_10: 'CI', // CI
          text_11: 'ACRA', // ACRA
          text_12: "Legal representative's shareholdering ratio over 25%.",
          text_13: 'Add Director',
          text_13_2: 'Add Commissioner',
          text_14: 'Director information',
          text_15: 'Passport',
          text_15_2: 'National ID',
          text_15_3: 'Front',
          text_15_4: 'Hong Kong and Macau Travel Permit',
          text_15_5: 'Photo',
          text_16: 'Upload Passport',
          text_17: 'Please upload scanned copy of passport.',
          text_17_2: 'Please upload your ID (front and back.)',
          text_17_3: ' Please ensure that the edges of your documents are clear and visible.',
          text_18: 'Delete',
          text_19: 'Shareholder information',
          text_20: 'You do not need to submit the same documents for the following steps.',
          text_21_1: 'Upload',
          text_21_2: 'See Example',
          text_22: 'Commissioner',
          text_23: 'NIB',
          text_24: 'Identification Picture',
          upload: " ",
          upload2: "Upload Certificate of Incorporation",
          uploadBR: "Upload BR",
          uploadBR2: "Upload BR",
          uploadCI: "Upload CI",
          uploadCI2: "Upload CI",
          uploadCO: "Controller and Ownership information",
          uploadACRA: "Upload ACRA",
          uploadACRA2: "Upload ACRA",
          uploadNib: 'NIB',
          uploadNib2: 'Upload NIB',
          uploadCert: "Certificate",
          uploadCert2: "Upload Certificate of Incorporation",
          maxFileOther: 'Upload the latest version of your Busienss License scanned copy and controller and ownership information (e.g. AoA or equivalent),'
        },
        error: { // auth.company.info.error.text_1
          text_1: 'Note:  Do not include special characters such as  [ ( .', // 注意：请不要输入全角符号，如：【（。
          text_2: 'Please upload ID front.', // 请上传证件正面
          text_3: 'Please upload ID back.', // 请上传证件反面
          text_4: 'Please upload business registration certification.', // 请上传企业证书
          text_5: 'Please upload business license',
          text_6: 'Please upload business license',
          upload: "Please upload business license",
          cert: "Please upload Certificate",
          sgCert: "Please upload Certificate of Incorporation",
          ACRA: "Please upload ACRA",
          uploadNib: "Please upload INDONESIA NIB",
          otherCert: "Please upload Certificate of Incorporation",
          maxLength128: "Maximum length is 128 characters",
        }
      },
      shareholder: { // auth.company.shareholder.text_1
        title: { // auth.company.shareholder.title.text_1
          text_1: 'Shareholder Information'
        },
        content: { // auth.company.shareholder.content.text_1
          text_1: '1.Please provide information of all shareholds with greater than 25%；', // 1.您需要提供所有持股25%以上的股东相关信息；
          text_2: '2.If there are multiple shareholders with more than 25% shareholding ratio, click the 【Add shareholder】 button.', // 2.若有多位股东持股超过25%请点击下方的【添加新股东】按钮
          text_3: '3.If there are no shareholders with more than 25% shareholding ratio, please provide the one with the greatest share.', // 3.如无持股25%以上的股东请填写持股最大的股东信息
          text_4: 'Add shareholder',
        }
      },
      business: { // auth.company.business.text_1
        title: { // auth.company.business.title.text_1
          text_1: 'Nature of Business',
          text_2: 'Business Information'
        },
        label: { // auth.company.business.label.text_1
          text_1: 'Nature of Business',
          text_2: 'Main referral customer type',
          text_3: 'Other details',
          text_5: 'Other details',
        },
        placeholder: { // auth.company.business.placeholder.text_1
          text_1: 'Other materials',
        },
        content: { // auth.company.business.content.text_1
          text_1: 'Fill in your industry, specific service information, and customer types. ', // 建议填写您的所在行业，具体服务内容，接触的客户类型；例如：我方为深圳知名出口电商培训机构XXXX公司的销售，主要为电商企业提供开店选品培训服务，拥有潜在出口电商客户500家；
          text_2: 'Fill in the main type of customers you will be referring.', // 建议填写您主要推荐客户类型，如：跨境电商卖家、出口贸易商等
          text_3: 'Upload other materials.',
          text_4: 'Next',
          text_5: 'Back',
          text_6: 'The file format should only be jpg, jpeg, png, bmp or pdf (Please ensure visibility of content, max file size 5MB)',
        },
        error: { // auth.company.business.error.text_1
          text_1: 'Please describe the nature of your business',
          text_2: 'Please fill in the main type of customers you will be referring.',
        }
      },
      overview: { // auth.company.overview.text_1
        title: { // auth.company.overview.title.text_1
          text_1: 'Overview',
          text_2: 'Identity information overview',
          text_3: 'Review Status ',
        },
        content: { // auth.company.overview.content.text_1
          text_1: 'Edit',
          text_2: 'Submit',
          text_3: 'Rejection remarks as below',
          text_4: 'Return to Dashboard',
          text_5: 'Picture of you holding up your front facing ID',
        },
      },
    },
    personal: {
      register: { // auth.personal.register.text_1
        title: { // auth.personal.register.title.text_1
          text_1: 'Applicant Information',
        },
        label: { // auth.personal.register.label.text_1
          text_1: 'Applicant Type',
          text_1_1: 'Individual',
          text_2: 'Legal Name',
          text_3: 'Legal Name (English)',
          text_4: 'ID Type',
          text_5: 'Resident Address',
          text_6: 'Resident Address (English)',
        },
        placeholder: { // auth.personal.register.placeholder.text_1
          text_1: 'Please enter your full legal name', // Please enter name
          text_2: 'Please enter your full legal name in English or pinyin', //
          text_3: 'Front', // + Front
          text_4: 'Back', // + Back
          text_5: 'Photo', //
          text_6: 'Please enter full resident address (Enter Chinese if applicable)', // Please enter full resident address (Enter Chinese if applicable)
        },
        error: { // auth.personal.register.error.text_1
          text_1: 'Please upload front ID picture',
          text_2: 'Please upload back ID picture',
          text_3: 'Please upload a picture of you holding up the front of your ID.',
          text_4: 'Please enter your address.',
          text_5: 'Please enter the pinyin of your address. ',
          text_6: 'Please select your account type.',
        },
        content: { // auth.personal.register.content.text_1
          text_1: 'Please upload picture / scanned copy of government-issued personal ID card. Move mouse over to upload box to',
          text_1_2: 'view sample',
          text_2: 'Upload in jpg, jpeg, png, bmp or pdf format (please ensure that text of the uploaded data is clearly visible, and the maximum size does not exceed 5MB).',
          text_3: 'ID Front',
          text_4: 'ID Back',
          text_5: 'Please upload a picture of the individual holding up the front of your ID. (We recommend using your back camera to ensure the image and your ID is clear and visible)',
          text_6: 'Next',
          text_7: 'Edit applicant type',
        },
      },
      business: {
        label: { // auth.company.business.label.text_1
          text_1: 'Nature of Business',
          text_2: 'Main referral customer type',
          text_3: 'Other details',
          text_4: 'Your business summary',
          text_5: 'Other details',
        }
      },
      overview: { // auth.company.overview.text_1
        title: { // auth.company.overview.title.text_1
          text_1: 'Overview',
          text_2: 'Applicant Information Overview',
          text_3: 'Review Status ',
        },
      },
    },
    authType: {
      title: { // auth.authType.title.text_1
        text_1: 'Business Registration',
        text_2: 'Individual Registration',
      },
      content: { // auth.authType.content.text_1
        text_1: 'Copy of Business Registration License/ACRA Biz File',
        text_2: 'Scanned copy of the legal representative/Authorised representative\'s ID',
        text_3: 'ID of shareholder with  25% shareholding or more.',
        text_4: 'ID Documents of Legal Representation/Authorised Representative/UBO, e.g., valid National ID, etc.',
        text_5: 'Photo of the applicant holding an identification document',
      },
      btn: { // auth.authType.btn.text_1
        text_1: 'Business Registration',
        text_2: 'Individual Registration',
      }
    },
  },
  client: {
    form: { // client.form.text_1
      text_1: 'Customer Name',
      text_2: 'Customer ID',
      text_3: 'Status',
      text_4: 'Registration Date',
      text_5: 'Valid Date Range',
      text_6: 'Invite Code',
      text_7: 'Register Date',
      submitDate: 'Submit Date',
    },
    placeholder: { // client.placeholder.text_1
      text_1: "Please enter customer's name",
      text_2: "Please enter the customer ID",
      text_3: "Select status",
      text_4: "Start",
      text_5: "End",
      inviteCode: "Please enter invite code",
    },
    table: { // client.table.text_1
      text_1: 'Customer Name',
      text_2: 'Customer ID',
      text_3: 'Status',
      text_4: 'Valid Date Cycle',
      text_5: 'Registration Date',
      text_6: 'Actions',
      text_7: 'KYC Update',
    },
    content: { // client.content.text_1
      text_1: 'Search',
      text_2: 'NO Data',
      text_3: 'Activated',
      text_4: 'Deactivated',
      text_5: 'Frozen',
      text_6: 'Export',
    },
    accountStatus: {
      text_1: 'Activated',
      text_2: 'Passed',
      text_3: 'Rejected',
      text_4: 'Not Processed',
      text_5: 'Assigned',
      text_6: 'Cancelled',
      text_7: 'Reset',
      text_8: 'Frozen',
    },
    accountTable: {
      text_1: 'Name',
      text_2: 'Platform',
      text_3: 'Country/Region',
      text_4: 'Currency',
      text_5: 'Account Number',
      text_6: 'Bank',
      text_7: 'Status',
      text_8: 'Applied on',
      text_9: 'Back',
      text_10: 'Collection Accounts',
      text_11: 'Activation Date',
      text_12: 'Opened Status',
      text_13: 'KYC Status',
      text_14: 'Submission Date',
    },
    registerType: {
      label: 'Registration Type',
      text_1: 'Individual',
      text_2: 'Company',
    },
    registerStatus: {
      text_0: 'Under verification',
      text_1: 'Verified',
      text_2: 'Under verification',
      text_3: 'Under verification',
      text_4: 'Returned',
      text_5: 'Under verification',
      text_6: 'Under verification',
      text_8: 'Annual Review',
      text_R: 'Under verification',
    },
    stepComplete: {
      label: 'KYC Status',
      text_0: 'Not Submitted',
      text_1: 'Submitted',
    },
  },
  salesSettlement: {
    form: {
      month: 'Bill Month',
    },
    placeholder: {
      month: 'Please enter bill month',
      startMonth: 'Start Month',
      endMonth: 'End Month',
    },
    table: {
      text_1: 'Bill Month',
      text_2: 'Invite Code',
      text_3: 'Remarks',
      text_4: 'Amount',
      text_5: 'TPV',
      text_6: 'Settled Time',
      text_7: 'Updated At',
    },
    content: {
      text_1: 'Search',
      text_2: 'No Data',
      text_3: 'Export',
      text_4: 'Sales Settlement by Invite Code',
    },
  },
  collection: {
    form: { // collection.form.text_1
      text_1: 'Customer Name',
      text_2: 'Currency',
      text_3: 'Date',
    },
    placeholder: { // collection.placeholder.text_1
      text_1: 'Select',
      text_2: 'Start',
      text_3: 'End',
    },
    table: { // collection.table.text_1
      text_1: 'Customer ID',
      text_2: 'Customer Name',
      text_3: 'Transaction No.',
      text_4: 'Amount',
      text_5: 'Currency',
      text_6: 'Submition Date',
      text_7: 'Fee',
      text_8: 'Transaction Date',
    },
    content: { // collection.content.text_1
      text_1: 'Search',
      text_2: 'No Data',
    },
    status: {
      pending: 'Pending',
      credited: 'Credited',
      returning: 'Returning',
      returned: 'Returned',
    },
    tips: {
      text_1: 'Submition Date',
      text_2: 'Transaction Date',
    }
  },
  settlement: {
    subTitle: 'Manage your referral commission',
    currentMonthTotal: 'Total Monthly Commission',
    confirmBill: 'Confirm Bill',
    billMonth: 'Bill Month',
    amount: 'Amount',
    settlementStatus: 'Status',
    settledTime: 'Settled Time',
    lastUpdateTime: 'Updated at',
    operation: 'Operations',
    updatedAt: 'Updated At',
    settleBill: 'Settle',
    viewBill: 'View',
    underReview: 'Pending',
    pending: 'Pending',
    settled: 'Settled',
    returned: 'Returned',
    faceTip: 'We recommend completing facial verification to proceed with settlement',
    pendingTip: 'Your bill has been confirmed. Please wait for settlement',
    notPushedTip: 'Your bill is not available yet. Please check again later',
    settledTip: 'Settled: Please check your settlement account for the funds',
    notFaceAuthTip: 'Not Face Auth',
    faceAuthPassedTip: 'Face Auth Passed',
    notFaceAuthAlert: 'You have not completed face authentication, please authenticate in time',
    proceed: 'Proceed',
    skip: 'Skip',
    tip: 'Tip',
    billAmount: 'Bill Amount',
    billCycle: 'Bill Month',
    bankAccount: 'Settlement Account',
    addBankAccount: 'Add Settlement Account',
    selectBankAccount: 'Please Select Settlement Account',
    lastUsed: 'Last Used',
    invoice: 'Invoice',
    uploadFile: 'Upload',
    notFaceAuthAlertTip: 'You have not completed face authentication, please authenticate in time to avoid affecting bill sending',
    noInvoiceTip: 'No uploaded invoices',
    pleaseUploadInvoice: 'Please upload invoices first',
    accountUnderReview: 'Unable to confirm the bill due to the invalid settlement account',
    pleaseSelectAccount: 'Please select a collection account',
    invoiceSizeLimit: 'Invoice file size cannot exceed 5M',
    maxInvoiceLimit: 'Maximum 20 invoices can be uploaded',
    expandDetail: 'Expand Detail',
    collapseDetail: 'Collapse Detail',
    totalUploadedInvoices: 'Total Invoices',
    invoiceTotal: 'Total Amount',
    verified: 'Verified',
    notVoided: 'Not Voided',
    voided: 'Voided',
    creditAdjusted: 'Credit Adjusted',
    partialCreditAdjusted: 'Partial Credit Adjusted',
    fullCreditAdjusted: 'Full Credit Adjusted',
    invoiceDuplicate: 'Duplicate Invoice',
    verificationFailed: 'Verification Failed',
    back: 'Back',
    unknownFile: 'Invoice',
    totalPrice: 'Total Price',
    deductibleAmount: 'Deductible Amount',
    invoiceDate: 'Invoice Date',
    invoiceDrawer: 'Invoice Drawer',
    title: 'Title',
    sellerName: 'Seller Name',
    sellerTaxNumber: 'Seller Tax Number',
    purchaseName: 'Purchase Name',
    purchaseTaxNumber: 'Purchase Tax Number',
    invoiceNumber: 'Invoice Number',
    pleaseCheck: 'Please reupload invoice to confirm the bill',
    modifySettlementInfo: 'Modify Settlement Info',
    settlementDetail: 'Settlement Detail',
    faceAuthTitle: 'Livess Verification',
    chooseVerificationMethod: 'You may choose either method to complete verification',
    method1: 'Method 1: Scan with your phone (recommended)',
    scanQRCodeTip: 'Please scan the QR code with your mobile and click the link to continue',
    method2: 'Method 2: Use your computer’s camera',
    cameraTip: 'Please ensure your computer is connected to a camera',
    verificationComplete: 'Completed Verification',
    startVerification: 'Start verification now',
    cancel: 'Cancel',
    verificationNote1: 'Please stay in a well-lit environment and remove any masks, sunglasses, or other obstructions',
    verificationNote2: 'Do not close this page until you finish the verification. For iOS system, please open the link in Safari',
    toConfirm: 'You have not completed verification'
  },
  trade: {
    form: { // trade.form.text_1
      text_1: 'Customer Name',
      text_2: 'Date',
      text_3: 'Processed On',
      text_4: 'Currency',
    },
    placeholder: { // trade.placeholder.text_1
      text_1: 'Select',
      text_2: 'Start',
      text_3: 'End',
    },
    table: { // trade.table.text_1
      text_1: 'Customer ID',
      text_2: 'Customer Name',
      text_3: 'Buy',
      text_4: 'Currency Bought',
      text_5: 'Sell',
      text_6: 'Currency Sold',
      text_7: 'Date',
      text_8: 'Processed On',
      text_9: 'Fee',
      text_10: 'Reference No.',
      text_11: 'Account Number',
      text_12: 'Status',
    },
    status: {
      lockedRate: 'Locked Rate',
      processing: 'Processing',
      sent: 'Sent'
    },
    tips: {
      text_1: 'Submition Date',
      text_2: 'Transaction Date'
    }
  },
  serverSide: {
    errorEnum: {
      /* eslint-disable */
      '500': 'Service unavailable',
      /* eslint-enable */
      SYS0001: 'Network error',
      SYS0002: 'Parameter error',
      SYS0003: 'File export exception',
      COM0001: 'Failed to add',
      COM0002: 'Edit failed',
      COM0003: 'Query failed',
      COM0004: 'Registration failed',
      COM0005: 'Submission failed',
      COM0006: 'Review failed',
      WJ0003: 'File encoding failed.',
      WJS0004: 'File decoding failed.',
      WJ0005: 'Failed to create directory.',
      WJ0006: 'Failed to read directory.',
      AT2010: 'You have exceeded the number of failed login attempts. Please try again later. ',
      AT2011: 'Login failure.',
      AT2012: 'User does not exist or invalid.',
      AT2013: 'The current mobile number has multiple accounts registered, please log in using your email address.',
      AT2014: 'The password cannot be reset through that mobile phone number.',
      AT2015: 'Invalid token.',
      AT2016: 'Access not granted',
      AT2021: 'Incorrect SMS verification code.',
      AT2022: 'Failed to send SMS verification code.',
      AT2023: 'Exceeded maximum SMS verification requests. Try again later. ',
      AT2024: 'Please send SMS verification code.',
      AT2025: 'Incorrect email verification code ',
      AT2026: 'The SMS verification code has expired.',
      AT2027: 'The email verification code has expired.',
      AT2028: 'Failed to send email.',
      AT2029: 'Account is invalid, please contact your account manager.',
      AT2050: "Password must contain special characters (!{'@'}#)",
      AT2051: 'Password length should be between 8-16 characters. ',
      AT2052: 'Password should only contain lower-case characters, upper-case characters and numbers. Special characters are not supported.',
      AT2053: 'Password must contain a number.',
      AT2054: 'The verification code has exceeded the maximum number of tries. Please retrieve a new code.',
      AT2055: 'You are already logged into a session elsewhere. This page is no longer active. ',
      AT2056: 'Exceeded maximum email verification requests. Try again later. ',
      AT2057: 'Incorrect original password.',
      AT2058: 'Failed to send review outcome via SMS.',
      AT2059: 'Failed to send DingTalk notification.',
      AT30001: 'Please upload verification documents and letter of authorisation.',
      AT3002: 'Failed to save file',
      AT3003: 'Please upload document details.',
      AT3004: 'Registration information not found. ',
      AT3005: 'Edits are only allowed for accounts that are rejected or pending review.',
      AT3006: 'File not found.',
      AT3007: 'Address (EN) cannot be in Mandarin.',
      AT3008: 'Change of applicant type is only allowed if verification has been rejected or not submitted. ',
      AT3009: 'Failed to change applicant type.',
      AT3010: 'Registration information is empty. Please fill in registration information first.',
      AT3011: 'Interface / endpoint error.',
      AT3012: 'Please fill in all required fields before submitting.',
      AT3013: 'Please review all information before submitting.',
      AT3014: 'Please fill in business information first.',
      AT3015: 'Please fill in registrant information first.',
      AT3016: 'Please review before proceeding.',
      AT3017: 'The start date must be before the end date.',
      AT3018: 'Accounts that have are under review or successful cannot be modified.',
      AT4001: 'Collection account not found.',
      AT4002: 'Collection account status error.',
      AT5001: 'The platform information has been published and cannot be edited. ',
      AT5002: 'The data has expired, please refresh and try again.',
      AT5003: 'Only drafts can be published.',
      AT5004: 'Only published messages can be removed.',
      AT5005: 'Please specify the template for the client before publishing.',
      AT5006: 'Registration details can only be modified if the application is under review.',
      AT5007: 'Please fill in reason for returning application before submitting.',
      '000000': 'Operation Successful',
      GW0402: 'Verification exception. Please ensure the acctId is accurate.',
      GW0300: 'Failed to verify information.',
      GW0301: 'Login failure.You are already logged into a session elsewhere. ',
      GW0900: 'Request object is empty.',
      GW0903: 'Response is empty.',
      GW0904: 'Request message error - failed to parse message. ',
      GW0905: 'Signature or encryption exception',
      GW0907: 'No corresponding algorithms.',
      GW0908: 'Invalid public key.',
      GW0909: 'Plain text error.',
      GW0911: 'Decryption failed',
      GW0912: 'Empty request message.',
      GW0915: 'System resources are non-repeatable,',
      GW0910: 'Null pointer exception',
      GW0302: "Token in 'cookie' is empty.",
      GW0504: 'The system has no corrresponding database configuration.',
      GW0505: 'Initialise the corresponding AppId syste. Database connection exception',
      GW0001: 'Request message expired.',
      GW0404: 'Request resource not found.',
      GW0403: 'Authentication exception.',
      GW0401: 'Verification exception. Please ensure appId is accurate.',
      GW0400: 'Parameter format error.',
      GW0901: 'Remote response authorisation exception.',
      GW0902: 'Third-party URL is empty. ',
      GW0906: 'Message parsing or decryption exception.',
      GW0914: 'Merchant information not found.',
      GW0999: '',
      GW0501: 'Service exception.',
      GW0502: 'No verification service available.',
      GW0506: 'Failed to verify signature.',
      GW0503: 'No corresponding authentication services.',
      GW0500: 'Service unavailable',
      AT5029: 'The invoice does not meet the requirements. Please reconfirm before submission',
      AT5030: 'Please ensure that the invoice amount matches the billing amount',
      AT5031: "This invoice has reached today's query limit. Please try again tomorrow."
    },
    customError: { // serverSide.customError.text_1
      text_1: 'Session has expired. Please login again.',
      text_2: 'You are not logged into your account. Please log in first. ',
      text_3: 'Back-end interface ({code}) exception.',
    }
  },
  component: {
    zoneNumber :{
      "enter": "Enter country / Region name or code",
      "noData": "No valid entries"
    }
  }
}
